/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

// Navigation items shared across all navigation types
const navigationItems: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'collapsable',
        icon : 'heroicons_outline:chart-pie',
        children: [
            {
                id   : 'dashboard.main-panel',
                title: 'Panel Principal',
                type : 'basic',
                icon : 'heroicons_outline:home',
                link : '/admin/dashboard/main-panel'
            },
            {
                id   : 'dashboard.top-agents',
                title: 'Top Agentes',
                type : 'basic',
                icon : 'heroicons_outline:trophy',
                link : '/admin/dashboard/top-agents'
            }
        ]
    },
    {
        id   : 'properties',
        title: 'Propiedades',
        type : 'collapsable',
        icon : 'heroicons_outline:home',
        children: [
            {
                id   : 'properties.list',
                title: 'Listado',
                type : 'basic',
                icon : 'heroicons_outline:queue-list',
                link : '/admin/properties'
            },
            {
                id   : 'properties.my-listings',
                title: 'Mis Propiedades',
                type : 'basic',
                icon : 'heroicons_outline:user',
                link : '/admin/properties/my-listings'
            },
            {
                id   : 'properties.capture-documents',
                title: 'Documentos Captacion',
                type : 'basic',
                icon : 'heroicons_outline:document-check',
                link : '/admin/properties/capture-documents'
            },
            {
                id   : 'properties.publications',
                title: 'Publicaciones',
                type : 'basic',
                icon : 'heroicons_outline:share',
                link : '/admin/properties/publications'
            }
        ]
    },
    {
        id      : 'divider-1',
        type    : 'divider'
    },
    // Clientes (contacts centralizados)
    {
        id   : 'clients',
        title: 'Clientes',
        type : 'collapsable',
        icon : 'heroicons_outline:users',
        children: [
            {
                id   : 'clients.list',
                title: 'Todos',
                type : 'basic',
                icon : 'heroicons_outline:queue-list',
                link : '/admin/clients'
            },
            {
                id   : 'clients.my-clients',
                title: 'Mis Clientes',
                type : 'basic',
                icon : 'heroicons_outline:user',
                link : '/admin/clients/my-clients'
            }
        ]
    },
    // ACM - Análisis Comparativo de Mercado
    {
        id   : 'acm',
        title: 'ACM',
        subtitle: 'Análisis de Mercado',
        type : 'collapsable',
        icon : 'heroicons_outline:chart-bar',
        children: [
            {
                id   : 'acm.internal-data',
                title: 'Datos Internos',
                type : 'basic',
                icon : 'heroicons_outline:circle-stack',
                link : '/admin/acm/internal-data'
            },
            {
                id   : 'acm.external-prices',
                title: 'Precios Externos Novus',
                type : 'basic',
                icon : 'heroicons_outline:currency-dollar',
                link : '/admin/acm/external-prices'
            },
            {
                id   : 'acm.manual',
                title: 'ACM Manual',
                type : 'basic',
                icon : 'heroicons_outline:pencil-square',
                link : '/admin/acm/manual'
            },
            {
                id   : 'acm.price-calculator',
                title: 'Cálculo Precio/m²',
                type : 'basic',
                icon : 'heroicons_outline:calculator',
                link : '/admin/acm/price-calculator'
            },
            {
                id   : 'acm.comparatives',
                title: 'Comparativos',
                type : 'basic',
                icon : 'heroicons_outline:presentation-chart-line',
                link : '/admin/acm/comparatives'
            }
        ]
    },
    // CRM
    {
        id   : 'crm',
        title: 'CRM',
        type : 'collapsable',
        icon : 'heroicons_outline:user-group',
        children: [
            {
                id   : 'crm.leads',
                title: 'Prospectos',
                type : 'basic',
                icon : 'heroicons_outline:user-plus',
                link : '/admin/crm/leads'
            },
            {
                id   : 'crm.deals',
                title: 'Oportunidades',
                type : 'basic',
                icon : 'heroicons_outline:briefcase',
                link : '/admin/crm/deals'
            },
            {
                id   : 'crm.followups',
                title: 'Tareas',
                type : 'basic',
                icon : 'heroicons_outline:clock',
                link : '/admin/crm/followups'
            },
            {
                id   : 'crm.stats',
                title: 'Reportes',
                type : 'basic',
                icon : 'heroicons_outline:chart-bar',
                link : '/admin/crm/stats'
            },
            {
                id   : 'crm.requirements',
                title: 'Recaudos',
                type : 'basic',
                icon : 'heroicons_outline:clipboard-document-list',
                link : '/admin/crm/requirements'
            }
        ]
    },
    // Legal
    {
        id   : 'legal',
        title: 'Legal',
        type : 'collapsable',
        icon : 'heroicons_outline:scale',
        children: [
            {
                id   : 'legal.requests',
                title: 'Solicitudes',
                type : 'basic',
                icon : 'heroicons_outline:document-text',
                link : '/admin/legal/requests'
            },
            {
                id   : 'legal.documents',
                title: 'Documentos',
                type : 'basic',
                icon : 'heroicons_outline:document-duplicate',
                link : '/admin/legal/documents'
            },
            {
                id   : 'legal.documentador-services',
                title: 'Servicios del documentador',
                type : 'basic',
                icon : 'heroicons_outline:clipboard-document-check',
                link : '/admin/legal/documentador-services'
            },
            {
                id   : 'legal.lawyers',
                title: 'Abogados',
                type : 'basic',
                icon : 'heroicons_outline:academic-cap',
                link : '/admin/legal/lawyers'
            },
            {
                id   : 'legal.progress',
                title: 'Progreso',
                type : 'basic',
                icon : 'heroicons_outline:arrow-trending-up',
                link : '/admin/legal/progress'
            },
            {
                id   : 'legal.signatures',
                title: 'Firmas',
                type : 'basic',
                icon : 'heroicons_outline:pencil-square',
                link : '/admin/legal/signatures'
            },
            {
                id   : 'legal.payments',
                title: 'Pagos',
                type : 'basic',
                icon : 'heroicons_outline:banknotes',
                link : '/admin/legal/payments'
            },
            {
                id   : 'legal.registry',
                title: 'Registro',
                type : 'basic',
                icon : 'heroicons_outline:building-library',
                link : '/admin/legal/registry'
            },
            {
                id   : 'legal.reports',
                title: 'Reportes',
                type : 'basic',
                icon : 'heroicons_outline:document-chart-bar',
                link : '/admin/legal/reports'
            },
            {
                id   : 'legal.templates',
                title: 'Plantillas',
                type : 'basic',
                icon : 'heroicons_outline:folder-arrow-down',
                link : '/admin/legal/templates'
            }
        ]
    },
    // Negociacion y Comisiones
    {
        id   : 'closings',
        title: 'Negociacion',
        subtitle: 'Cierres y Comisiones',
        type : 'collapsable',
        icon : 'heroicons_outline:clipboard-document-check',
        children: [
            {
                id   : 'closings.contacts',
                title: 'Contactos',
                type : 'basic',
                icon : 'heroicons_outline:users',
                link : '/admin/closings/contacts'
            },
            {
                id   : 'closings.negotiation',
                title: 'Solicitudes',
                type : 'basic',
                icon : 'heroicons_outline:chat-bubble-left-right',
                link : '/admin/closings/negotiation'
            },
            {
                id   : 'closings.my-closings',
                title: 'Mis Cierres',
                type : 'basic',
                icon : 'heroicons_outline:user-circle',
                link : '/admin/closings/my-closings'
            },
            {
                id   : 'admin-management.my-finances',
                title: 'Mis Finanzas',
                type : 'basic',
                icon : 'heroicons_outline:banknotes',
                link : '/admin/management/my-finances'
            },
            {
                id   : 'closings.list',
                title: 'Cierres y Comisiones',
                type : 'basic',
                icon : 'heroicons_outline:currency-dollar',
                link : '/admin/closings'
            },
            {
                id   : 'admin-management.agent-payments',
                title: 'Pagos a Asesores',
                type : 'basic',
                icon : 'heroicons_outline:banknotes',
                link : '/admin/management/agent-payments'
            },
            {
                id   : 'closings.banking',
                title: 'Bancarización',
                type : 'basic',
                icon : 'heroicons_outline:building-library',
                link : '/admin/closings/banking'
            }
        ]
    },
    // Administración
    {
        id   : 'admin-management',
        title: 'Administración',
        type : 'collapsable',
        icon : 'heroicons_outline:building-office',
        children: [
            {
                id   : 'admin-management.finances',
                title: 'Balance General',
                type : 'basic',
                icon : 'heroicons_outline:scale',
                link : '/admin/management/finances'
            },
            {
                id   : 'admin-management.finances.beneficiaries',
                title: 'Finanzas por Beneficiario',
                type : 'basic',
                icon : 'heroicons_outline:users',
                link : '/admin/management/finances/beneficiaries'
            },
            {
                id   : 'admin-management.income',
                title: 'Ingresos Negociaciones',
                type : 'basic',
                icon : 'heroicons_outline:arrow-trending-up',
                link : '/admin/management/income'
            },
            {
                id   : 'admin-management.petty-cash',
                title: 'Cajas y Bancos',
                type : 'basic',
                icon : 'heroicons_outline:wallet',
                link : '/admin/management/petty-cash'
            },
            {
                id   : 'admin-management.condo-receipts',
                title: 'Gastos de Condominio',
                type : 'basic',
                icon : 'heroicons_outline:envelope',
                link : '/admin/management/condo-receipts'
            },
            {
                id   : 'admin-management.membership-payments',
                title: 'Pagos de Membresía',
                type : 'basic',
                icon : 'heroicons_outline:banknotes',
                link : '/admin/management/membership-payments'
            },
            {
                id   : 'admin-management.payroll',
                title: 'Nómina',
                type : 'basic',
                icon : 'heroicons_outline:users',
                link : '/admin/management/payroll'
            },
            {
                id   : 'admin-management.testimonials',
                title: 'Testimonios',
                type : 'basic',
                icon : 'heroicons_outline:chat-bubble-bottom-center-text',
                link : '/admin/management/testimonials'
            },
            {
                id   : 'admin-management.private-docs',
                title: 'Documentos Privados',
                type : 'basic',
                icon : 'heroicons_outline:lock-closed',
                link : '/admin/management/private-docs'
            },
            {
                id   : 'admin-management.monthly-reports',
                title: 'Informes Mensuales',
                type : 'basic',
                icon : 'heroicons_outline:calendar-days',
                link : '/admin/management/monthly-reports'
            },
            {
                id   : 'admin-management.audit-log',
                title: 'Auditoría Financiera',
                type : 'basic',
                icon : 'heroicons_outline:clipboard-document-list',
                link : '/admin/management/audit-log'
            }
        ]
    },
    {
        id      : 'divider-2',
        type    : 'divider'
    },
    // Usuarios y Roles
    {
        id   : 'users',
        title: 'Usuarios',
        type : 'collapsable',
        icon : 'heroicons_outline:users',
        children: [
            {
                id   : 'users.list',
                title: 'Usuarios',
                type : 'basic',
                icon : 'heroicons_outline:user',
                link : '/admin/users/list'
            },
            {
                id   : 'users.agents',
                title: 'Agentes',
                type : 'basic',
                icon : 'heroicons_outline:identification',
                link : '/admin/users/agents'
            },
            {
                id   : 'users.external-agents',
                title: 'Agentes Externos',
                type : 'basic',
                icon : 'heroicons_outline:user-plus',
                link : '/admin/users/external-agents'
            },
            {
                id   : 'users.roles',
                title: 'Roles y Permisos',
                type : 'basic',
                icon : 'heroicons_outline:shield-check',
                link : '/admin/users/roles'
            }
        ]
    },
    // Configuración
    {
        id   : 'settings',
        title: 'Configuración',
        type : 'collapsable',
        icon : 'heroicons_outline:cog-6-tooth',
        children: [
            {
                id   : 'settings.locations',
                title: 'Ubicaciones',
                type : 'basic',
                icon : 'heroicons_outline:map',
                link : '/admin/settings/locations'
            },
            {
                id   : 'settings.real-estate-agencies',
                title: 'Inmobiliarias',
                type : 'basic',
                icon : 'heroicons_outline:building-office-2',
                link : '/admin/settings/real-estate-agencies'
            },
            {
                id   : 'settings.system-parameters',
                title: 'Parametros del Sistema',
                type : 'basic',
                icon : 'heroicons_outline:adjustments-horizontal',
                link : '/admin/settings/system-parameters'
            },
            {
                id   : 'settings.journals',
                title: 'Diarios',
                type : 'basic',
                icon : 'heroicons_outline:book-open',
                link : '/admin/settings/journals'
            },
            {
                id   : 'settings.petty-cash-categories',
                title: 'Categorías de Caja Chica',
                type : 'basic',
                icon : 'heroicons_outline:tag',
                link : '/admin/settings/petty-cash-categories'
            },
            {
                id   : 'settings.legal-templates',
                title: 'Plantillas Legales',
                type : 'basic',
                icon : 'heroicons_outline:document-arrow-up',
                link : '/admin/settings/legal-templates'
            }
        ]
    }
];

export const defaultNavigation: FuseNavigationItem[] = [...navigationItems];
export const compactNavigation: FuseNavigationItem[] = [...navigationItems];
export const futuristicNavigation: FuseNavigationItem[] = [...navigationItems];
export const horizontalNavigation: FuseNavigationItem[] = [...navigationItems];
